// extracted by mini-css-extract-plugin
export var customCol = "partners-grid-module--customCol--c2be7";
export var customGrid = "partners-grid-module--customGrid--0bb39";
export var heading = "partners-grid-module--heading--9cb7c";
export var item = "partners-grid-module--item--bb8ea";
export var items = "partners-grid-module--items--1f35e";
export var root = "partners-grid-module--root--f5475";